import verifyToken from './verify-token';

export { verifyToken };

export default verifyToken;
